/**
 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Status
 */

export enum HttpStatusKind {
  /** 1xx responses */
  INFORMATIONAL = 'informational',
  /** 2xx responses */
  SUCCESSFUL = 'successful',
  /** 3xx responses */
  REDIRECTION = 'redirection',
  /** 4xx responses */
  CLIENT_ERROR = 'client error',
  /** 5xx responses */
  SERVER_ERROR = 'server error',
  /** other (unknown) responses */
  UNKNOWN = 'unknown status code'
}
